export default __webpack_public_path__ + "static/media/LightspeedFiji.d69daf75.png";